/* eslint-disable @typescript-eslint/no-explicit-any */
import "moment/locale/es";

const SinDatos = () => {
  return (
    <div className="">
          <label className="cursor-pointer block w-full mb-4 p-4 rounded-lg bg-white">
            No hay datos para mostrar...
          </label>
    </div>
  );
};

export default SinDatos;
